<template>
    <div class="not-found relative relative w-full h-screen overflow-hidden">
        <router-link :to="{path : '/'}">
            <div class="not-found__background-container overflow-hidden">
                <svg xmlns="http://www.w3.org/2000/svg"  version="1.1" viewBox="0 0 147.73 105.15" class="not-found__background h-screen mx-auto" >
                    <clipPath id="numberClip">
                        <path class="cls-1" d="M16.59,0H38.32V66.82h6.93v14.5H38.32v23.83H22.38V81.32H.16L0,68.43Zm5.79,30.43L16.59,66.82h5.79Z"/><path class="cls-1" d="M59.12,99.53A18.28,18.28,0,0,1,53.2,85.8V19.5A18.3,18.3,0,0,1,59.12,5.77,20.06,20.06,0,0,1,73.48,0,19.53,19.53,0,0,1,87.83,5.77,18.31,18.31,0,0,1,93.76,19.5V85.8a18.29,18.29,0,0,1-5.93,13.73,20,20,0,0,1-14.35,5.62A20.55,20.55,0,0,1,59.12,99.53ZM78.31,85.8V19.5c0-3.12-2.18-5.46-4.83-5.46s-4.84,2.34-4.84,5.46V85.8c0,3,2.34,5.46,4.84,5.46S78.31,88.77,78.31,85.8Z"/><path class="cls-1" d="M119.07,0h21.74V66.82h6.92v14.5h-6.92v23.83H124.87V81.32H102.65l-.16-12.89Zm5.8,30.43-5.8,36.39h5.8Z"/>
                    </clipPath>
                    <filter id="distortionFilter">
                        <feTurbulence ref="turbulence" type="fractalNoise" baseFrequency="0.01 0.003" numOctaves="5" seed="2" stitchTiles="noStitch" x="0%" y="0%" width="100%" height="100%" result="noise"/>
                        <feDisplacementMap ref="displacementMap" in="SourceGraphic" in2="noise" scale="0" xChannelSelector="R" yChannelSelector="B" x="0%" y="0%" width="100%" height="100%" filterUnits="userSpaceOnUse"/>
                    </filter>
                    <image xlink:href="@/assets/images/404-background.jpg" width="147.73" height="105.15" :style="'filter:url(#distortionFilter); -webkit-clip-path: url('+ pageUrl +'#numberClip); clip-path: url('+ pageUrl +'#numberClip); '"/>
                </svg>
            </div>

            <div class="not-found__title-container">
                <div class="not-found__client-content overflow-hidden">
                    <h2 class="not-found__title font-coign-bold text-black text-8xl md:text-20xl leading-none tracking-minwide uppercase whitespace-no-wrap text-center"><span class="not-found__title-text">Not found</span></h2>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    export default {
        name : 'not-found',

        computed : {
            pageUrl(){
                return window.location.href;
            }
        },
    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .not-found {
        &__background-container, &__title-container {
            @include top-left(50%, 50%);
            transform : translate(-50%, -50%);
        }
    }
</style>